import { domain } from 'modules/data';
import { memo, useCallback, useState } from 'react';
import { AccountingDomainEntitiesSynchronizationStatus } from 'shared/data/webApp/v2';
import { useCompanyBasedOnUrl } from 'shared/hooks/useCompanyBasedOnUrl';

import { BudgetTile } from '../../../BudgetTile/BudgetTile';
import { ActionsMenu } from '../ActionsMenu/ActionsMenu';
import { BudgetParams } from '../BudgetParams/BudgetParams';
import { BudgetListItemProps } from './BudgetListItem.types';

export const BudgetListItem = memo<BudgetListItemProps>((props) => {
    const { budget, isBudgetSyncEnabled } = props;

    const { name, isEnabled, synchronizationStatus } = budget;

    const company = useCompanyBasedOnUrl();

    const [isForceSyncing, setIsForceSyncing] = useState(false);

    const isSyncInProgress = synchronizationStatus === AccountingDomainEntitiesSynchronizationStatus.in_progress;
    const isSyncFailed = synchronizationStatus === AccountingDomainEntitiesSynchronizationStatus.failed;

    const handleForceSyncStart = useCallback(() => {
        setIsForceSyncing(true);
    }, []);

    const handleForceSyncEnd = useCallback(() => {
        setIsForceSyncing(false);
    }, []);

    return (
        <BudgetTile
            name={name}
            isEnabled={isEnabled}
            isSyncInProgress={isSyncInProgress || isForceSyncing}
            isSyncFailed={isSyncFailed}
            origin={domain.BudgetOrigin.QBooks}
            budgetParams={<BudgetParams company={company} budget={budget} />}
            actionsMenu={
                <ActionsMenu
                    budget={budget}
                    company={company}
                    isBudgetSyncEnabled={isBudgetSyncEnabled}
                    onSyncEnd={handleForceSyncEnd}
                    onSyncStart={handleForceSyncStart}
                />
            }
        />
    );
});

BudgetListItem.displayName = 'BudgetListItem';
